export const CanvaZoomChangeActionType = 'CHANGE_CANVA_ZOOM';
export const canvaZoomReducer = (state, action) => {
    switch (action.type) {
        case CanvaZoomChangeActionType:
            return action.payload;
        default:
            return state;
    }
};
